import script from "./AlloyConfigSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AlloyConfigSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__